export enum EnContentType {
    Json,
    XML
}